import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {MotifNavigationIcMoreVert24px} from '@ey-xd/motif-icon';

import Dropdown from '../../../CoreWrappers/Dropdown';
import Button from '../../../CoreWrappers/Button';

const Menu = ({items = null}) => {
	const [open, setOpen] = useState(false);

	if (!items) return false;

	const renderTrigger = () => {
		const props = {
			className: 'menu-trigger',
			svg: MotifNavigationIcMoreVert24px,
			variant: 'ghost',
			onClick: () => setOpen(!open)
		};

		return <Button {...props} />;
	};

	const props = {
		className: 'menu-dropdown',
		open,
		placement: 'bottom-start',
		trigger: renderTrigger(),
		reversed: true,
		topfix: true
	};

	if (items) props.items = items;

	return <Dropdown {...props} />;
};

Menu.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			onClick: PropTypes.func.isRequired
		})
	)
};

export default Menu;
